// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.manual-asset-page {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
  color: var(--ca-text-primary, #172033);
}

.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0.25rem 0 1.5rem;
}

.heading-copy {
  min-width: 0;
}
.heading-copy h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.5rem, 2.2vw, 1.95rem);
  font-weight: 750;
  letter-spacing: -0.035em;
}

.eyebrow {
  margin-bottom: 0.45rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.heading-copy > p {
  max-width: 760px;
  margin: 0.55rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.92rem;
  line-height: 1.6;
}

.heading-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  flex: 0 0 3.5rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border: 1px solid rgba(40, 80, 173, 0.15);
  border-radius: var(--ca-radius-lg, 12px);
  font-size: 1.45rem;
}

.manual-asset-card {
  overflow: hidden;
  background: var(--ca-surface, #fff);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.card-intro {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 1.35rem clamp(1.1rem, 2.5vw, 2rem);
  background: linear-gradient(180deg, #fbfcff 0%, #f7f9fd 100%);
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.card-intro-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border-radius: var(--ca-radius-md, 8px);
  font-size: 1.1rem;
}

.card-intro h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
}

.card-intro p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.5;
}

.required-note {
  margin-left: auto;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  white-space: nowrap;
}

.required-mark {
  color: var(--ca-danger, #dc3545);
  font-weight: 800;
}

.form-section {
  padding: clamp(1.2rem, 2.6vw, 2rem);
}
.form-section + .form-section {
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.section-heading {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: 1.5rem;
}

.section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border-radius: 0.55rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.section-heading h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 750;
}

.section-heading p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem 1.5rem;
}

.field-group {
  min-width: 0;
}

.field-full {
  grid-column: 1/-1;
}

.field-group .form-label {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 650;
}

.form-control,
.form-select {
  min-height: 42px;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  color: var(--ca-text-primary, #172033);
  font-size: 0.875rem;
  box-shadow: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}
.form-control:hover:not(:disabled):not([readonly]),
.form-select:hover:not(:disabled):not([readonly]) {
  border-color: var(--ca-border-dark, #c7cfdd);
}
.form-control:focus,
.form-select:focus {
  border-color: var(--ca-primary-light, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);
}
.form-control.is-invalid,
.form-select.is-invalid {
  border-color: var(--ca-danger, #dc3545);
  background-image: none;
}
.form-control[readonly],
.form-select[readonly] {
  color: var(--ca-text-secondary, #4b5870);
  background: var(--ca-bg-secondary, #eef2f8);
  cursor: not-allowed;
}

.description-input {
  min-height: 112px;
  resize: vertical;
}

.field-footer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.3rem;
}

.character-count,
.field-hint {
  display: block;
  margin-top: 0.35rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  line-height: 1.45;
}

.field-footer .field-error {
  margin-top: 0.05rem;
}

.character-count {
  flex: 0 0 auto;
}

.field-error {
  display: block;
  margin-top: 0.35rem;
  color: var(--ca-danger, #dc3545);
  font-size: 0.74rem;
  line-height: 1.4;
}

.optional-label {
  margin-left: 0.4rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  font-weight: 500;
}

.source-reference {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 58px;
  padding: 0.7rem 0.85rem;
  background: var(--ca-bg-secondary, #eef2f8);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-sm, 6px);
}

.source-reference-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  color: var(--ca-primary, #0e2e80);
  background: #fff;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 6px;
  font-size: 1.1rem;
}

.source-reference-copy {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}
.source-reference-copy strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.79rem;
}
.source-reference-copy span {
  overflow-wrap: anywhere;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.76rem;
}

.source-status {
  flex-shrink: 0;
  padding: 0.3rem 0.5rem;
  color: var(--ca-success, #198754);
  background: var(--ca-success-bg, #eaf7f0);
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
}

.input-with-prefix {
  position: relative;
}
.input-with-prefix > i {
  position: absolute;
  top: 50%;
  left: 0.85rem;
  z-index: 1;
  color: var(--ca-text-muted, #8c96a8);
  transform: translateY(-50%);
}
.input-with-prefix .form-control {
  padding-left: 2.45rem;
}

.business-value-field {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.business-value-field .form-control {
  max-width: 180px;
}

.out-of-ten {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.85rem;
  font-weight: 600;
}

.form-error-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin: 0 clamp(1.2rem, 2.6vw, 2rem) 1rem;
  padding: 0.85rem 1rem;
  color: #842029;
  background: var(--ca-danger-bg, #fdecef);
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.82rem;
  line-height: 1.45;
}
.form-error-banner i {
  margin-top: 0.1rem;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem clamp(1.2rem, 2.6vw, 2rem);
  background: #fbfcfe;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.form-actions-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  line-height: 1.4;
}
.form-actions-note i {
  color: var(--ca-success, #198754);
  font-size: 1rem;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.7rem;
  flex-shrink: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0.55rem 1rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.82rem;
  font-weight: 650;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-cancel {
  color: var(--ca-text-secondary, #4b5870);
  background: #fff;
  border: 1px solid var(--ca-border, #dfe4ec);
}
.btn-cancel:hover:not(:disabled) {
  color: var(--ca-text-primary, #172033);
  background: var(--ca-bg-secondary, #eef2f8);
  border-color: var(--ca-border-dark, #c7cfdd);
}

.btn-save {
  color: #fff;
  background: var(--ca-primary, #0e2e80);
  border: 1px solid var(--ca-primary, #0e2e80);
  box-shadow: 0 2px 5px rgba(14, 46, 128, 0.12);
}
.btn-save:hover:not(:disabled) {
  color: #fff;
  background: var(--ca-primary-dark, #0d2863);
  border-color: var(--ca-primary-dark, #0d2863);
}
.btn-save:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 3px;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.loading-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 280px;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.875rem;
}

@media (max-width: 767.98px) {
  .page-heading {
    align-items: flex-start;
  }
  .heading-mark {
    width: 2.8rem;
    height: 2.8rem;
    flex-basis: 2.8rem;
    font-size: 1.15rem;
  }
  .card-intro {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .required-note {
    width: 100%;
    margin-left: 3.6rem;
  }
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 1.05rem;
  }
  .field-full {
    grid-column: auto;
  }
  .form-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .action-buttons {
    justify-content: flex-end;
  }
}
@media (max-width: 480px) {
  .manual-asset-page {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .heading-mark {
    display: none;
  }
  .card-intro {
    gap: 0.7rem;
    padding: 1rem;
  }
  .form-section {
    padding: 1.1rem 1rem;
  }
  .form-actions {
    padding: 1rem;
  }
  .form-error-banner {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .action-buttons {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
  }
  .action-buttons .btn {
    width: 100%;
    padding-right: 0.6rem;
    padding-left: 0.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/system-asset-capture/system-asset-manual-create-or-update/system-asset-manual-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,sCAAA;AAFF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,wBAAA;AANF;;AASA;EACE,YAAA;AANF;AAQE;EACE,SAAA;EACA,sCAAA;EACA,wCAAA;EACA,gBAAA;EACA,wBAAA;AANJ;;AAUA;EACE,sBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,6CAAA;EACA,yCAAA;EACA,wCAAA;EACA,kBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,mCAAA;EACA,iDAAA;EACA,wCAAA;EACA,iEAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;EACA,6DAAA;EACA,wDAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,iBAAA;AAPF;;AAUA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,gCAAA;EACA,gBAAA;AAPF;;AAUA;EACE,mCAAA;AAPF;AASE;EACE,qDAAA;AAPJ;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AARF;;AAWA;EACE,SAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,cAAA;EACA,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAWA;;EAEE,gBAAA;EACA,6CAAA;EACA,uCAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uFAAA;AARF;AAUE;;EACE,4CAAA;AAPJ;AAUE;;EACE,8CAAA;EACA,gDAAA;AAPJ;AAUE;;EACE,uCAAA;EACA,sBAAA;AAPJ;AAUE;;EACE,wCAAA;EACA,2CAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,iBAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AARF;;AAWA;;EAEE,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,cAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAWA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,iDAAA;EACA,kBAAA;EACA,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;AARF;AAUE;EACE,sCAAA;EACA,kBAAA;AARJ;AAWE;EACE,uBAAA;EACA,wCAAA;EACA,kBAAA;AATJ;;AAaA;EACE,cAAA;EACA,sBAAA;EACA,iCAAA;EACA,yCAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;AAYE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;EACA,2BAAA;AAVJ;AAaE;EACE,qBAAA;AAXJ;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAZF;AAcE;EACE,gBAAA;AAZJ;;AAgBA;EACE,uCAAA;EACA,kBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,yCAAA;EACA,qBAAA;EACA,cAAA;EACA,wCAAA;EACA,2CAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AAbF;AAeE;EACE,kBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,0CAAA;EACA,mBAAA;EACA,qDAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAdF;AAgBE;EACE,iCAAA;EACA,eAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;AAfF;;AAkBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uFAAA;AAfF;;AAkBA;EACE,wCAAA;EACA,gBAAA;EACA,2CAAA;AAfF;AAiBE;EACE,sCAAA;EACA,2CAAA;EACA,4CAAA;AAfJ;;AAmBA;EACE,WAAA;EACA,sCAAA;EACA,4CAAA;EACA,6CAAA;AAhBF;AAkBE;EACE,WAAA;EACA,2CAAA;EACA,6CAAA;AAhBJ;AAmBE;EACE,mDAAA;EACA,mBAAA;AAjBJ;;AAqBA;EACE,mBAAA;EACA,aAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE;IACE,uBAAA;EAlBF;EAqBA;IACE,aAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;EAnBF;EAsBA;IACE,uBAAA;IACA,eAAA;EApBF;EAuBA;IACE,WAAA;IACA,mBAAA;EArBF;EAwBA;IACE,qCAAA;IACA,YAAA;EAtBF;EAyBA;IACE,iBAAA;EAvBF;EA0BA;IACE,oBAAA;IACA,sBAAA;EAxBF;EA2BA;IACE,yBAAA;EAzBF;AACF;AA4BA;EACE;IACE,sBAAA;IACA,qBAAA;EA1BF;EA6BA;IACE,aAAA;EA3BF;EA8BA;IACE,WAAA;IACA,aAAA;EA5BF;EA+BA;IACE,oBAAA;EA7BF;EAgCA;IACE,aAAA;EA9BF;EAiCA;IACE,kBAAA;IACA,iBAAA;EA/BF;EAkCA;IACE,aAAA;IACA,gCAAA;EAhCF;EAmCA;IACE,WAAA;IACA,qBAAA;IACA,oBAAA;EAjCF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.manual-asset-page {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\n  color: var(--ca-text-primary, #172033);\n}\n\n// .ca-breadcrumbs {\n//   margin: 0 0 1rem;\n// }\n\n.page-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin: 0.25rem 0 1.5rem;\n}\n\n.heading-copy {\n  min-width: 0;\n\n  h1 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: clamp(1.5rem, 2.2vw, 1.95rem);\n    font-weight: 750;\n    letter-spacing: -0.035em;\n  }\n}\n\n.eyebrow {\n  margin-bottom: 0.45rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.heading-copy > p {\n  max-width: 760px;\n  margin: 0.55rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.92rem;\n  line-height: 1.6;\n}\n\n.heading-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.5rem;\n  height: 3.5rem;\n  flex: 0 0 3.5rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border: 1px solid rgba(40, 80, 173, 0.15);\n  border-radius: var(--ca-radius-lg, 12px);\n  font-size: 1.45rem;\n}\n\n.manual-asset-card {\n  overflow: hidden;\n  background: var(--ca-surface, #fff);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n}\n\n.card-intro {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  padding: 1.35rem clamp(1.1rem, 2.5vw, 2rem);\n  background: linear-gradient(180deg, #fbfcff 0%, #f7f9fd 100%);\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.card-intro-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.7rem;\n  height: 2.7rem;\n  flex: 0 0 2.7rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 1.1rem;\n}\n\n.card-intro h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.05rem;\n  font-weight: 750;\n}\n\n.card-intro p {\n  margin: 0.25rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n  line-height: 1.5;\n}\n\n.required-note {\n  margin-left: auto;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.75rem;\n  white-space: nowrap;\n}\n\n.required-mark {\n  color: var(--ca-danger, #dc3545);\n  font-weight: 800;\n}\n\n.form-section {\n  padding: clamp(1.2rem, 2.6vw, 2rem);\n\n  & + .form-section {\n    border-top: 1px solid var(--ca-border-light, #e9edf3);\n  }\n}\n\n.section-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  margin-bottom: 1.5rem;\n}\n\n.section-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  flex: 0 0 2rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border-radius: 0.55rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.section-heading h3 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1rem;\n  font-weight: 750;\n}\n\n.section-heading p {\n  margin: 0.25rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem 1.5rem;\n}\n\n.field-group {\n  min-width: 0;\n}\n\n.field-full {\n  grid-column: 1 / -1;\n}\n\n.field-group .form-label {\n  display: block;\n  margin-bottom: 0.45rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n  font-weight: 650;\n}\n\n.form-control,\n.form-select {\n  min-height: 42px;\n  border-color: var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-sm, 6px);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.875rem;\n  box-shadow: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n\n  &:hover:not(:disabled):not([readonly]) {\n    border-color: var(--ca-border-dark, #c7cfdd);\n  }\n\n  &:focus {\n    border-color: var(--ca-primary-light, #2850ad);\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);\n  }\n\n  &.is-invalid {\n    border-color: var(--ca-danger, #dc3545);\n    background-image: none;\n  }\n\n  &[readonly] {\n    color: var(--ca-text-secondary, #4b5870);\n    background: var(--ca-bg-secondary, #eef2f8);\n    cursor: not-allowed;\n  }\n}\n\n.description-input {\n  min-height: 112px;\n  resize: vertical;\n}\n\n.field-footer {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-top: 0.3rem;\n}\n\n.character-count,\n.field-hint {\n  display: block;\n  margin-top: 0.35rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  line-height: 1.45;\n}\n\n.field-footer .field-error {\n  margin-top: 0.05rem;\n}\n\n.character-count {\n  flex: 0 0 auto;\n}\n\n.field-error {\n  display: block;\n  margin-top: 0.35rem;\n  color: var(--ca-danger, #dc3545);\n  font-size: 0.74rem;\n  line-height: 1.4;\n}\n\n.optional-label {\n  margin-left: 0.4rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  font-weight: 500;\n}\n\n.source-reference {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-height: 58px;\n  padding: 0.7rem 0.85rem;\n  background: var(--ca-bg-secondary, #eef2f8);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-sm, 6px);\n}\n\n.source-reference-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  flex: 0 0 2rem;\n  color: var(--ca-primary, #0e2e80);\n  background: #fff;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 6px;\n  font-size: 1.1rem;\n}\n\n.source-reference-copy {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n\n  strong {\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.79rem;\n  }\n\n  span {\n    overflow-wrap: anywhere;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.76rem;\n  }\n}\n\n.source-status {\n  flex-shrink: 0;\n  padding: 0.3rem 0.5rem;\n  color: var(--ca-success, #198754);\n  background: var(--ca-success-bg, #eaf7f0);\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.input-with-prefix {\n  position: relative;\n\n  > i {\n    position: absolute;\n    top: 50%;\n    left: 0.85rem;\n    z-index: 1;\n    color: var(--ca-text-muted, #8c96a8);\n    transform: translateY(-50%);\n  }\n\n  .form-control {\n    padding-left: 2.45rem;\n  }\n}\n\n.business-value-field {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n\n  .form-control {\n    max-width: 180px;\n  }\n}\n\n.out-of-ten {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.form-error-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  margin: 0 clamp(1.2rem, 2.6vw, 2rem) 1rem;\n  padding: 0.85rem 1rem;\n  color: #842029;\n  background: var(--ca-danger-bg, #fdecef);\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.82rem;\n  line-height: 1.45;\n\n  i {\n    margin-top: 0.1rem;\n  }\n}\n\n.form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.2rem clamp(1.2rem, 2.6vw, 2rem);\n  background: #fbfcfe;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.form-actions-note {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.75rem;\n  line-height: 1.4;\n\n  i {\n    color: var(--ca-success, #198754);\n    font-size: 1rem;\n  }\n}\n\n.action-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.7rem;\n  flex-shrink: 0;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 0.55rem 1rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.82rem;\n  font-weight: 650;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.btn-cancel {\n  color: var(--ca-text-secondary, #4b5870);\n  background: #fff;\n  border: 1px solid var(--ca-border, #dfe4ec);\n\n  &:hover:not(:disabled) {\n    color: var(--ca-text-primary, #172033);\n    background: var(--ca-bg-secondary, #eef2f8);\n    border-color: var(--ca-border-dark, #c7cfdd);\n  }\n}\n\n.btn-save {\n  color: #fff;\n  background: var(--ca-primary, #0e2e80);\n  border: 1px solid var(--ca-primary, #0e2e80);\n  box-shadow: 0 2px 5px rgba(14, 46, 128, 0.12);\n\n  &:hover:not(:disabled) {\n    color: #fff;\n    background: var(--ca-primary-dark, #0d2863);\n    border-color: var(--ca-primary-dark, #0d2863);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ca-primary-light, #2850ad);\n    outline-offset: 3px;\n  }\n}\n\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.loading-panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  min-height: 280px;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.875rem;\n}\n\n@media (max-width: 767.98px) {\n  .page-heading {\n    align-items: flex-start;\n  }\n\n  .heading-mark {\n    width: 2.8rem;\n    height: 2.8rem;\n    flex-basis: 2.8rem;\n    font-size: 1.15rem;\n  }\n\n  .card-intro {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .required-note {\n    width: 100%;\n    margin-left: 3.6rem;\n  }\n\n  .form-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 1.05rem;\n  }\n\n  .field-full {\n    grid-column: auto;\n  }\n\n  .form-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .action-buttons {\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .manual-asset-page {\n    padding-right: 0.25rem;\n    padding-left: 0.25rem;\n  }\n\n  .heading-mark {\n    display: none;\n  }\n\n  .card-intro {\n    gap: 0.7rem;\n    padding: 1rem;\n  }\n\n  .form-section {\n    padding: 1.1rem 1rem;\n  }\n\n  .form-actions {\n    padding: 1rem;\n  }\n\n  .form-error-banner {\n    margin-right: 1rem;\n    margin-left: 1rem;\n  }\n\n  .action-buttons {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr;\n  }\n\n  .action-buttons .btn {\n    width: 100%;\n    padding-right: 0.6rem;\n    padding-left: 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
